import { render } from "./PerformancePeriodTable.vue?vue&type=template&id=85969436"
import script from "./PerformancePeriodTable.vue?vue&type=script&lang=js"
export * from "./PerformancePeriodTable.vue?vue&type=script&lang=js"

import "./PerformancePeriodTable.vue?vue&type=style&index=0&id=85969436&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__